<template>
  <v-dialog
    v-model="dialog"
    max-width="520px"
    scrollable
  >
    <v-card>
      <v-card-title>
        {{ p_nuevo ? 'Nuevo turno' : (editar ? 'Editar turno' : 'Detalle') }}
        <v-spacer></v-spacer>
        <v-switch
          v-if="!p_nuevo"
          v-model="editar"
          label="Editar"
          class="my-1"
          hide-details
          dense
        ></v-switch>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="form">
          <v-row class="pt-8">
            <v-col cols="12" md="6" class="py-0">
              <v-autocomplete
                v-model="turno.tipo"
                label="Tipo"
                :items="$store.state.tipos_turno"
                :autofocus="editar"
                :readonly="!editar"
                :filled="!editar"
                outlined
                dense
                @change="refrescar_estados()"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-autocomplete
                v-model="turno.estado"
                label="Estado"
                item-text="nombre"
                item-value="nombre"
                :items="estados_turno"
                :readonly="!editar"
                :filled="!editar"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <FechaPicker
                label="Fecha"
                :disabled="!editar"
                :p_fecha.sync="turno.fecha"
              />
            </v-col>
            <v-col cols="6" class="py-0">
              <TimePicker
                label="Hora inicio"
                :disabled="!editar"
                :horario_restringido="true"
                :hora.sync="turno.hora"
              />
            </v-col>
            <v-col cols="6" class="py-0">
              <TimePicker
                label="Hora fin"
                :disabled="!editar"
                :hora.sync="turno.duracion"
              />
            </v-col>
            <v-col cols="11" md="5" class="ml-1 py-0">
              <v-switch
                v-model="turno.activo"
                label="Turno activo"
                class="my-1"
                :true-value="1"
                :false-value="0"
                :readonly="!editar"
                dense
              ></v-switch>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model.trim="turno.cliente"
                label="Cliente"
                :readonly="!editar"
                :filled="!editar"
                outlined
                dense
              ></v-text-field>
            </v-col>
             <v-col cols="12" class="py-0">
              <v-text-field
                v-model.trim="turno.vehiculo"
                label="Vehículo"
                :readonly="!editar"
                :filled="!editar"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model.trim="turno.servicio"
                label="Servicio"
                :readonly="!editar"
                :filled="!editar"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-autocomplete
                v-model="turno.mecanico"
                label="Asesor"
                :items="$store.state.mecanicos"
                :readonly="!editar"
                :filled="!editar"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <!-- <v-col cols="12" md="6" class="py-0">
              <v-text-field
                v-model.trim="turno.asesor"
                label="Mecanico"
                :readonly="!editar"
                :filled="!editar"
                outlined
                dense
              ></v-text-field>
            </v-col> -->
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="d-flex justify-end py-4">
        <v-btn
          v-text="editar ? 'Cancelar' : 'Volver'"
          :color="editar ? 'error' : ''"
          dark
          @click="dialog = false"
        ></v-btn>
        <v-btn
          v-if="editar"
          color="success"
          class="ml-4"
          @click="guardar()"
        >
          Guardar
          <v-icon right>fas fa-save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 *  Modal para editar o crear una turno
 * 
 *  Notas: este componente emite acciones (@nuevo, @editar) al padre caundo se crea o edita una turno (en caso de estar definidas)
 *         todos los props son obligatorios
 */
import { parseDate } from '../utils'
import FechaPicker from './utils/FechaPicker'
import TimePicker from './utils/TimePicker'

export default {
  data () {
    return {
      load: false,
      editar: false,
      estados_turno: [],
      turno: {},
      rules: {
        required: value => !!value || 'Campo requerido',
      }
    }
  },
  created () {
    this.get_data()
  },
  props: {
    value: Boolean,
    p_nuevo: Boolean, // para editar un turno enviar en false, para un turno nuevo en true
    p_turno: Object   // en caso de ser nuevo enviar el objeto con los atributros en null desde el padre
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
  },
  components: {
    FechaPicker,
    TimePicker
  },
  watch: {
    dialog (val) {
      if (val) {
        if (this.p_nuevo) {
          // si es nuevo setea los campos en null y activo en 1
          this.turno = {
            tipo: null,
            estado: null,
            activo: 1,
            fecha: null,
            hora: null,
            cliente: null,
            vehiculo: null,
            mecanico: null,
            asesor: null,
            servicio: null,
            duracion: null
          }
          this.editar = true
        } else {
          // copia el prop p_turno en turno para editarlo
          this.refrescar_turno()
          this.editar = false
        }
      } else {
        this.$refs.form.resetValidation()
      }
    },
    editar (val) {
      // vuelve a dejar el turno como estaba originalmente
      val || this.refrescar_turno()
    }
  },
  methods: {
    async guardar () {
      if (this.$refs.form.validate()) {
        //pasa a mayusculas el texto
        this.uppercase('cliente')
        this.uppercase('vehiculo')
        this.uppercase('servicio')
        this.uppercase('asesor')
        // pasa la fecha a timestamp y agrega la nueva variable al turno
        this.turno.timestamp = + new Date(parseDate(this.turno.fecha))
        // guarda
        this.$store.state.loading = true
        if (this.p_nuevo) {
          await this.$store.dispatch('nuevo_turno', this.turno)
            .then((res) => {
              this.dialog = false
              this.$emit('nuevo', res.data)
              this.$swal.fire({
                icon: 'success',
                title: res.message
              })
            })
            .catch((error) => {
              this.$swal.fire({
                icon: 'error',
                title: 'Error al dar de alta el turno',
                text: error
              })
            })
        } else {
          await this.$store.dispatch('editar_turno', this.turno)
            .then((res) => {
              this.dialog = false
              this.$emit('editar', res.data)
              this.$swal.fire({
                icon: 'success',
                title: res.message
              })
            })
            .catch((error) => {
              this.$swal.fire({
                icon: 'error',
                title: 'Error al dar de alta el turno',
                text: error
              })
            })
        }
        this.$store.state.loading = false
      }
    },
    async get_data () {
      // obtiene los mecanicos solo si el array es vacio
      if (this.$store.state.mecanicos.length == 0) {
        this.$store.state.loading = true
        await this.$store.dispatch('get_mecanicos')
          .then(() => {
            // todo ok
          })
          .catch(error => {
            this.$swal.fire({
              icon: 'error',
              title: 'Error al obtener los mecanicos',
              text: error,
            })
          })
        this.$store.state.loading = false
      }
    },
    refrescar_estados () {
      const tipo = this.turno.tipo
      if (tipo == 'ENTREGA') {
        this.estados_turno = this.$store.state.estados_turno.filter(estado => estado.entrega == 1)
      } else if (tipo == 'POSTVENTA') {
        this.estados_turno = this.$store.state.estados_turno
      } else {
        this.estados_turno = []
      }
      // si es nuevo selecciona el primer estado
      if (this.p_nuevo) {
        this.turno.estado = this.$store.state.estados_turno[0].nombre 
      }
    },
    refrescar_turno () {
      this.turno = JSON.parse(JSON.stringify(this.p_turno))
      this.refrescar_estados()
    },
    uppercase (atributro) {
      if (this.turno[atributro]) {
        this.turno[atributro] = this.turno[atributro].toUpperCase()
      }
    }
  }
}
</script>